export default {
  myDrafts: 'My Drafts',
  titles: {
    individuals: 'Individual Drafts',
    businesses: 'Business Drafts',
    pricings: 'Pricing Drafts',
  },
  fields: {
    noResultsFound: 'No results found',
    searchInProgress: 'Search is in progress...',
    title: 'Object name',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    type: 'Type',
    createType: 'CREATE',
    updateType: 'UPDATE',
    createdAtFrom: 'Created after',
    createdAtTo: 'Created before',
    objectId: 'Object Id',
    allDrafts: 'All drafts',
    onlyCreate: 'Only create',
    onlyUpdate: 'Only update',
  },
};
